import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import es from './locales/es.json';
import en from './locales/en.json';
import esBinders from './locales/es.binders.json';
import enBinders from './locales/en.binders.json';
import esAccount from './locales/es.account.json';
import enAccount from './locales/en.account.json';
import esRarity from './locales/es.rarity.json';
import enRarity from './locales/en.rarity.json';
import esCommunity from './locales/es.community.json';
import enCommunity from './locales/en.community.json';
import esAnalyzer from './locales/es.analyzer.json';
import enAnalyzer from './locales/en.analyzer.json';
import esTournament from './locales/es.tournament.json';
import enTournament from './locales/en.tournament.json';
import esPlay from './locales/es.play.json';
import enPlay from './locales/en.play.json';

// Los diccionarios se dividen por dominio para evitar un único archivo gigante.
// Todos comparten el mismo namespace `translation`.
const esResources = { ...es, ...esBinders, ...esAccount, ...esCommunity, ...esRarity, ...esAnalyzer, ...esTournament, ...esPlay };
const enResources = { ...en, ...enBinders, ...enAccount, ...enCommunity, ...enRarity, ...enAnalyzer, ...enTournament, ...enPlay };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: esResources },
      en: { translation: enResources },
    },
    lng: localStorage.getItem('i18nextLng') || 'es',
    fallbackLng: 'es',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
